import { Observable, Subject } from 'rxjs';

class Options {
    public interval:number
}

export class SuperObserveQueue {

    private subscribed = false;
    private interval = 1000;
    private _items = [];
    public items = [];
    public length = 0;
    private items$ = new Subject();
    private function = new Function();
    private history = false;
    public state:string = "standby";

    constructor(func:Function, options?:Options) {
        this.function = func
        if(options && options.interval>=0) this.interval = options.interval
        this.init()
    }
    
    private insert = (x) => {
        this.subscribed = true
        return Observable.create( (observer) => {
            const doIt = () => {
                this.length = this._items.length
                if(this.length>0) {
                    const item = this._items[0]
                    this._items.shift()
                    this.state = "running"
                    observer.next(item)
                }
                else {
                    this.subscribed = false
                    clearInterval(int)
                    this.state = "standby"
                    observer.complete();
                }
            }
            doIt()
            const int = setInterval( doIt, this.interval)
        });
    }
    
    private init() {
        this.items$.subscribe( x => {
            this._items.push(x)
            if(this.history) {
                this.items.push(x)
            }
            if(!this.subscribed) {
                this.insert(x).subscribe( (item) => {
                    this.function(item)
                }, (error) => {
                    console.log(error)
                }, () => {
                    // console.log("complete")
                })
            }
        })
    }
    
    /// Add an object to queue. 
    public push(x:any) {
        if(Array.isArray(x)) {
            x.map( _x => {
                this.items$.next(_x)
            })
        }
        else {
            this.items$.next(x)
        }
    }

    public remaining() {
        return this._items.length * this.interval
    }

}
